// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer-module__root__3Gt6Y","right":"Footer-module__right__3n_7f","left":"Footer-module__left__LZtRm"};